import React, { useEffect, useState } from "react";
import WebinarItem from "./WebinarItem";
import { Link } from "react-router-dom";
import { base_url } from "../../Api/Api";
import Skltn from "./skltnWebinar";

const Webinar = (props) => {
  const [state, setState] = useState({
    timstamp: false,
    webinar: [],
    contentStatus: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    base_url
      .get(`webinars`)
      .then((response) => {
        setState({
          ...state,
          webinar: response.data.webinars,
          contentStatus: response.data.webinars.length !== 0,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <div className="webinar">
      <div className="contain">
        <div className="webinar-body">
          <div className="backward">
            <span>وبینارهای من</span>
            <span onClick={() => props.history.goBack()}>
              بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i>
            </span>
          </div>
          <div className="web-body">
            {state.webinar.length == 0 ? (
              <Skltn />
            ) : state.contentStatus ? (
              state.webinar.map((info, info_index) => {
                return (
                  <WebinarItem
                    key={info.id ? info.id : info_index}
                    data={info}
                  />
                );
              })
            ) : (
              <span className="no-content">موردی برای نمایش وجود ندارد.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Webinar;
